// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__IX6t8","orientation_vertical":"Divider_orientation_vertical__-mQNJ","orientation_horizontal":"Divider_orientation_horizontal__sf3cA"};